export const UPDATE_PAGE_HEAD = 'update_page_head'

export const updatePageHead = payload => {
  return {
    type: UPDATE_PAGE_HEAD,
    payload
  }
}
